let blockquote_array = Array.from(document.getElementsByTagName("blockquote"));
let blockquote_1 = blockquote_array[0];

//Get img_obj from webflow CMS
let script = document.querySelector('[data-element="speaker_data"]');
let img_obj = JSON.parse(script.textContent);

/////Inserting profile picture & image after each blockquote
blockquote_array.forEach(function (blockquote) {
  blockquote.style.marginBottom = "0";
  blockquote.insertAdjacentHTML(
    "afterend",
    `<div class="quote_speaker"><img alt="" loading="lazy" class="client_img" src="${img_obj.img_url}" style="width: 40px;"><div class="client_name-desig-wrapper"><div class="client_name">${img_obj.person_name}</div><div class="client_desig">${img_obj.person_desig}</div></div></div>
    `
  );
});

////Modifying profile picture width of each picture
let client_img_class_array = Array.from(
  document.querySelectorAll(".client_img")
);
client_img_class_array.forEach(function (client_img_class) {
  client_img_class.style.width = "40px";
});

////////////////////////////////////////////////////////////////////////////////////////
//Indentation for paragraphs/////

let list_arr = Array.from(document.querySelectorAll("ul"));

let feach_arr = list_arr.forEach(function (ul) {
  let p_after_ul = ul.nextElementSibling;
  if (p_after_ul.tagName.toLocaleLowerCase() == "p") {
    p_after_ul.style.marginLeft = "24px";
  } else {
    console.log("Not p");
  }
});
